<template>
    <div>
        <UiCardListHeader
            :title="lang('calendar.widgets.time_info.title')"
            :action-href="route('calendar.admin.sync.logs')"
            :action-label="lang('calendar.widgets.time_info.actions.show')"
        />

        <table class="w-full mb-2 text-xs">
            <tbody class="divide-y divide-neutral-200 dark:divide-neutral-900">
                <tr>
                    <th class="w-40 py-1 text-left">
                        {{ lang('calendar.widgets.time_info.current_time') }}
                    </th>
                    <td class="py-1" :class="{ 'animate-pulse': loading }">
                        {{ info.current_time }}
                    </td>
                </tr>
                <tr>
                    <th class="w-40 py-1 text-left">
                        {{ lang('calendar.widgets.time_info.sync_interval') }}
                    </th>
                    <td class="py-1" :class="{ 'animate-pulse': loading }">
                        {{ info.sync_interval }}
                    </td>
                </tr>
                <tr>
                    <th class="w-40 py-1 text-left">
                        {{ lang('calendar.widgets.time_info.sync_service') }}
                    </th>
                    <td class="py-1" :class="{ 'animate-pulse': loading }">
                        {{ info.sync_service }}
                    </td>
                </tr>
                <tr>
                    <th class="w-40 py-1 text-left">
                        {{ lang('calendar.widgets.time_info.timezone') }}
                    </th>
                    <td class="py-1" :class="{ 'animate-pulse': loading }">
                        {{ info.timezone }}
                    </td>
                </tr>
                <tr>
                    <th class="w-40 py-1 text-left">
                        {{ lang('calendar.widgets.time_info.offset') }}
                    </th>
                    <td class="py-1" :class="{ 'animate-pulse': loading }">
                        {{ info.offset }}
                    </td>
                </tr>
                <tr>
                    <th class="w-40 py-1 text-left">
                        {{ lang('calendar.widgets.time_info.timezone_offset') }}
                    </th>
                    <td class="py-1" :class="{ 'animate-pulse': loading }">
                        {{ info.timezone_offset }}
                    </td>
                </tr>
            </tbody>
        </table>

        <p class="text-xs text-center text-neutral-500 dark:text-neutral-400">
            {{ lang('calendar.widgets.time_info.help') }}
        </p>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const loading = ref(false);

const info = ref({
    current_time: '',
    sync_interval: '',
    sync_service: '',
    timezone: '',
    offset: '',
    timezone_offset: '',
});

const load = () => {
    loading.value = true;

    axios
        .get(route('calendar.admin.api.time'))
        .then(({ data }) => {
            if (data.info) {
                info.value = data.info;
            }
        })
        .finally(() => {
            loading.value = false;
        });
};

load();

setInterval(() => {
    load();
}, 60000);
</script>
